<!-- Header -->
<h2 mat-dialog-title>
    <span *ngIf="searchAndSelect">Staff Search and Select</span>
    <span *ngIf="!searchAndSelect">Staff Search</span>
</h2>

<!-- Body -->
<mat-dialog-content>
    <form id="staffSearchControls" (keydown)="keyDownFunction($event)" class="side-padding">
        <div style="display: flex;flex-direction: row;padding-left: 10px;">
            <tyl-form-field class="searchField" label="Last Name">
                <input matInput id='inpLastName' name='LastName' type='text' [(ngModel)]='lastName'
                    [disabled]="checkAdvancedFilter()" />
            </tyl-form-field>

            <tyl-form-field class="searchField" label="First Name" style="padding-left: 10px;">
                <input matInput id='inpFirstName' name='FirstName' type='text' [(ngModel)]='firstName'
                    [disabled]="checkAdvancedFilter()" />
            </tyl-form-field>

            <tyl-form-field label='School' class="searchField">
                <mat-select id='ddlSchool' [(ngModel)]='selectedSchoolId' name='School'
                    [disabled]="checkAdvancedFilter()">
                    <mat-option *ngIf="schools.length > 1" [value]='-1'>(All)</mat-option>
                    <mat-option *ngFor='let school of schools' [value]='school.Id'>{{school.SchoolName}}</mat-option>
                </mat-select>
            </tyl-form-field>

            <tyl-form-field label='Permission Group' class="searchField" *ngIf="!isV10">
                <mat-select id='ddlPermissionGroup' [(ngModel)]='selectedPermissionGroupId' name='Role'
                    [disabled]="checkAdvancedFilter()">
                    <mat-option *ngFor='let pg of permissionGroups' [value]='pg.ID'>{{pg.Description}}</mat-option>
                </mat-select>
            </tyl-form-field>

            <tyl-form-field label="Staff Filter"
                [hint]="checkAdvancedFilter() && !currentQuery.QueryName ? 'Unsaved Filter Applied' : null"
                class="searchField">
                <mat-select aria-label="Staff Filter Select" id="staffFilterInput" name="staffFilterInput"
                    [(ngModel)]="currentQuery">
                    <mat-option [value]="null">
                        None
                    </mat-option>
                    <mat-option *ngFor="let recentFilter of information.recentStaffFilters" [value]="recentFilter">
                        {{recentFilter.QueryName}}
                    </mat-option>
                </mat-select>
            </tyl-form-field>
        </div>

        <div style="display: flex;flex-direction: row;padding-left: 10px;">
            <tyl-form-field [label]='isV10 ? "Employee Number" : "Employee #"' class="searchField">
                <input matInput id='inpEmployeeNumber' name='EmployeeNumber' type='text' [(ngModel)]='employeeNumber'
                    [disabled]="checkAdvancedFilter()" />
            </tyl-form-field>

            <tyl-form-field label='Username' class="searchField" *ngIf="!isV10">
                <input matInput id='inpUsername' name='Username' type='text' [(ngModel)]='userName'
                    [disabled]="checkAdvancedFilter()" />
            </tyl-form-field>

            <tyl-form-field label='Role' class="searchField" *ngIf="!isV10">
                <mat-select id='ddlRole' [(ngModel)]='selectedRoleId' name='Role' [disabled]="checkAdvancedFilter()">
                    <mat-option *ngFor='let Role of Roles' [value]='Role.Id'>{{Role.RoleName}}</mat-option>
                </mat-select>
            </tyl-form-field>

            <tyl-radio-group *ngIf="!isV10" [(selected)]="staffStatus" [values]="['Active', 'Inactive', 'All']"
                [labels]="['Active', 'Inactive', 'All']" [ids]="['rbActive', 'rbInActive', 'rbAll']"
                arrange='horizontal' style='margin-top: 15px;margin-left: 10px;' [disabled]="checkAdvancedFilter()">
            </tyl-radio-group>
            <tyl-form-field label="Status" class="searchField" *ngIf="isV10">
                <mat-select name='staffStatus' id="staffStatus" [(ngModel)]="staffStatus"
                    [disabled]="checkAdvancedFilter()">
                    <mat-option value="All">
                        All
                    </mat-option>
                    <mat-option value="Active">
                        Active
                    </mat-option>
                    <mat-option value="Inactive">
                        Inactive
                    </mat-option>
                </mat-select>
            </tyl-form-field>

            <div class="label-input-block" style="position: relative; top: -6px">
                <tyl-button style="padding-left: 20px;" image="search normal.png" (clickEvent)="searchClick()"
                    translate></tyl-button>
            </div>
        </div>
    </form>


    <div style="flex:1; overflow:auto;">
        <div style="flex: 1;line-height: 8; display: flex; justify-content: center; align-items: center;" *ngIf="dataSource.data.length == 0 && !isBusy" translate>
            No data matches selected search criteria.
        </div>
       
        <div class="menuPosition" *ngIf="dataSource.data.length > 0">
            <img class="menuButton" [matMenuTriggerFor]="gridMenu"
                src="./assets/images/icons/baseline_menu.png" />
            <mat-menu #gridMenu="matMenu">
                <div style="padding-right: 10px;" *ngFor="let column of defaultColumns">
                    <mat-checkbox id="StaffSearchColumnCheckbox{{column}}"
                        [checked]="columnActive(column)"
                        (change)="addColumn(column)"
                        (click)="$event.stopPropagation()">
                        {{getColumnHeader(column)}}
                    </mat-checkbox>
                </div>
                <button mat-button (click)="restoreDefaultsClick()">Restore Defaults</button>
            </mat-menu>
        </div>
        <mat-table #table [dataSource]="dataSource" matSortDisableClear matSort id="tblStaff" matSortActive=""
                matSortDirection="asc" *ngIf="dataSource.data.length > 0">

                <ng-container matColumnDef="select">
                    <mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (click)="$event.stopPropagation();$event.preventDefault(); checkAll()"
                            [checked]="allSelected">
                        </mat-checkbox>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-checkbox (click)="$event.stopPropagation();$event.preventDefault(); staffSelected(element)"
                            [checked]="element.Selected">
                        </mat-checkbox>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Employee Number">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="EmployeeNumber">
                        {{isV10 ? 'Employee Number' : 'Employee #' | translate}}
                        <filter class="mat-filter" [data]="dataSource" columnName="EmployeeNumber" dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.EmployeeNumber}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="First Name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="FirstName">
                        <span translate>First Name</span>
                        <filter class="mat-filter" [data]="dataSource" columnName="FirstName" dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.FirstName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Middle Name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="MiddleName">
                        <span translate>Middle Name</span>
                        <filter class="mat-filter" [data]="dataSource" columnName="MiddleName" dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.MiddleName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Last Name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="LastName">
                        <span translate>Last Name</span>
                        <filter class="mat-filter" [data]="dataSource" columnName="LastName" dataType="string"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.LastName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Staff Name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="StaffName">
                        <Span translate>Name</Span>
                        <filter class="mat-filter" [data]="dataSource" columnName="StaffName" dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.StaffName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Username">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="Username">
                        <span translate>Username</span>
                        <filter class="mat-filter" [data]="dataSource" columnName="UserName" dataType="string"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.UserName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="School Name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="SchoolName">
                        {{isV10 ? 'Primary School' : 'School' | translate}}
                        <filter class="mat-filter" [data]="dataSource" columnName="SchoolName" dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.SchoolName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Permission Group">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="PermissionsGroup">
                        <span translate>Permissions Group</span>
                        <filter class="mat-filter" [data]="dataSource" columnName="PermissionGroup" dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.PermissionGroup}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Inactive Date">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="InActiveDate" >
                        <span translate>Inactive Date</span>
                        <filter class="mat-filter" [data]="dataSource" columnName="InActiveDate" dataType="date">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"
                        [ngStyle]="{'background-color': element.InActiveDate <= todayDate && element.InActiveDate != '' ? '#ffff8d' : ''}">
                        {{element.InActiveDate | date:'MM/dd/yy'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Staff Role">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="StaffRole">
                        {{isV10 ? 'Primary Job' : 'Role' | translate}}
                        <filter class="mat-filter" [data]="dataSource" columnName="StaffRole" dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.StaffRole}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Staff Status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="StaffStatus">
                        <span translate>Status</span>
                        <filter class="mat-filter" [data]="dataSource" columnName="StaffStatus" dataType="string">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.StaffStatus}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Use In Scheduling">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="UseInScheduling">
                        <span translate>Use In Scheduling</span>
                        <filter class="mat-filter" [data]="dataSource" columnName="UseInScheduling" dataType="boolean">
                        </filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.UseInScheduling ? 'Y' : ''}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="State Id">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="StateId">
                        <span translate>State Id</span>
                        <filter class="mat-filter" [data]="dataSource" columnName="StateId" dataType="string"></filter>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.StateId}} </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = renderIndex;" id="tblStaffDataRow{{i}}"
                    (click)="rowSelected(row)" style="padding:0px;overflow: hidden;" matRipple>
                </mat-row>

        </mat-table>
    </div>
    <mat-paginator [pageSizeOptions]="[100, 250, 500]" showFirstLastButtons *ngIf="dataSource.data.length > 0"></mat-paginator>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>
    <div class='flex-footer-left'>
        <tyl-button *ngIf="!isV10" image="startover.png" label="Start Over" (clickEvent)="startOverClick()" translate>
        </tyl-button>
        <tyl-button [image]="checkAdvancedFilter() ? 'filter yellow.png' : 'filter.png'" label="Staff Filters"
            (clickEvent)="staffFiltersClick()"></tyl-button>
        <tyl-button *ngIf="searchAndSelect"
            [image]="selectedStaff.length == 0 ? 'student black.png' : 'student yellow.png'" label="Selected Staff"
            (clickEvent)="showSelectedStaff()" translate></tyl-button>
    </div>
    <div class='flex-footer-middle'>
        <tyl-checkbox *ngIf="!isV10" [disabled]="checkAdvancedFilter()" id='chkAllSchool' [(checked)]="showAllSchool"
            (change)="showAllSchoolClick()">
            <span translate>Show all schools</span>
        </tyl-checkbox>
        <filter-notification [filtered]="isDataFiltered()" (clearFilter)="clearFilter()"></filter-notification>
    </div>
    <div class='flex-footer-right'>
        <tyl-button *ngIf="searchAndSelect" image="save.png" label="Select" (clickEvent)="selectClick()"></tyl-button>
        <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>
